import React, { Fragment } from "react";
import PropTypes from "prop-types";
import ReactTooltip from "react-tooltip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuestionCircle, faTimes } from "@fortawesome/free-solid-svg-icons";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import urls from "../utils/urls";
import {
  QuestionMark,
  BackDrop,
  CloseButton,
  GraphicsWrapper,
  Graphics,
  Description,
  Slide,
  Animation,
} from "./styles/kanban-how-to-styles";

const KanbanHowTo = ({ isRecruiter, howToModalActive, toggleHowToModal }) => {
  const settings = {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  // recruiter slides desktop/mobile
  const showConfirmInterview = () => {
    if (window.innerWidth < 500) {
      return (
        <Animation
          src={`${urls.images_production}/kanban_images/confirminginterviewmobile.gif`}
          mobile
          alt="Confirm interview GIF"
        />
      );
    }
    return (
      <Animation
        src={`${urls.images_production}/kanban_images/confirminterview.gif`}
        alt="Confirm interview GIF"
      />
    );
  };

  const showAcceptJobOffer = () => {
    if (window.innerWidth < 500) {
      return (
        <Animation
          src={`${urls.images_production}/kanban_images/acceptjoboffermobile.gif`}
          mobile
          alt="Accept job offer GIF"
        />
      );
    }
    return (
      <Animation
        src={`${urls.images_production}/kanban_images/acceptjoboffer.gif`}
        alt="Accept job offer GIF"
      />
    );
  };

  const showWithdrawCandidate = () => {
    if (window.innerWidth < 500) {
      return (
        <Animation
          src={`${urls.images_production}/kanban_images/withdrawcandidatemobile.gif`}
          mobile
          alt="Withdraw candidate GIF"
        />
      );
    }
    return (
      <Animation
        src={`${urls.images_production}/kanban_images/withdrawcandidate.gif`}
        alt="Withdraw candidate GIF"
      />
    );
  };

  // employer slides desktop/mobile
  const showDragNDropHowTo = () => {
    if (window.innerWidth < 500) {
      return (
        <Animation
          src={`${urls.images_production}/kanban_images/dragdropmobile.gif`}
          mobile
          alt="Drag and drop GIF"
        />
      );
    }
    return (
      <Animation
        src={`${urls.images_production}/kanban_images/dragdrop.gif`}
        alt="Drag and drop GIF"
      />
    );
  };

  const showDragNDropHowToSubmit = () => {
    if (window.innerWidth < 500) {
      return (
        <Animation
          src={`${urls.images_production}/kanban_images/submitmobile.gif`}
          mobile
          alt="Submit GIF"
        />
      );
    }
    return (
      <Animation
        src={`${urls.images_production}/kanban_images/submit.gif`}
        alt="Submit GIF"
      />
    );
  };

  const showMakeOffer = () => {
    if (window.innerWidth < 500) {
      return (
        <Animation
          src={`${urls.images_production}/kanban_images/makeoffermobile.gif`}
          mobile
          alt="Make offer GIF"
        />
      );
    }
    return (
      <Animation
        src={`${urls.images_production}/kanban_images/makeoffer.gif`}
        alt="Make offer GIF"
      />
    );
  };

  return (
    <Fragment>
      {!howToModalActive && (
        <QuestionMark
          id="kanban-how-to"
          data-tip="Help"
          data-for="kanban-how-to"
          onClick={toggleHowToModal}
          className="animated bounceInRight"
        >
          <FontAwesomeIcon icon={faQuestionCircle} />
        </QuestionMark>
      )}
      <ReactTooltip
        place="top"
        type="dark"
        effect="solid"
        aria-haspopup="true"
        id="kanban-how-to"
      />
      <BackDrop className={howToModalActive && "animated fadeIn"}>
        <CloseButton
          onClick={toggleHowToModal}
          className="animated fadeInDown delayOne"
        >
          <FontAwesomeIcon icon={faTimes} />
        </CloseButton>
        <GraphicsWrapper className="animated fadeInDown delayTwo">
          {isRecruiter ? (
            <Slider {...settings}>
              <Slide>
                <Graphics>{showConfirmInterview()}</Graphics>
                <Description desktop>
                  <span>Confirming</span> an interview.
                </Description>
                <Description mobile>
                  <span>Confirming</span> an interview.
                </Description>
              </Slide>
              <Slide>
                <Graphics>{showAcceptJobOffer()}</Graphics>
                <Description desktop>
                  <span>Accepting</span> a job <span>offer</span>.
                </Description>
                <Description mobile>
                  <span>Accepting</span> a job <span>offer</span>.
                </Description>
              </Slide>
              <Slide>
                <Graphics>{showWithdrawCandidate()}</Graphics>
                <Description desktop>
                  <span>Withdrawing</span> a candidate.
                </Description>
                <Description mobile>
                  <span>Withdrawing</span> a candidate. <br />(
                  <span>tap & hold</span> candidate card to <span>drag</span> it
                  <span> between columns</span>)
                </Description>
              </Slide>
            </Slider>
          ) : (
            <Slider {...settings}>
              <Slide>
                <Graphics>{showDragNDropHowTo()}</Graphics>
                <Description desktop>
                  <span>Drag</span> and <span>drop</span> candidate card
                  <span> between columns</span>. <br />
                </Description>
                <Description mobile>
                  <span>Tap, hold</span> and <span>drag</span> candidate card
                  <span> between columns</span>. <br />
                </Description>
              </Slide>
              <Slide>
                <Graphics>{showDragNDropHowToSubmit()}</Graphics>
                <Description>
                  Submit your <span>action</span>.
                </Description>
              </Slide>
              <Slide>
                <Graphics>{showMakeOffer()}</Graphics>
                <Description desktop>
                  To <span>make a job offer</span> - click a{" "}
                  <span>handshake</span> icon on the candidate card,{" "}
                  <span>add your message</span> and submit an action.
                </Description>
                <Description mobile>
                  To <span>make a job offer</span> - tap on the{" "}
                  <span>handshake</span> icon on the candidate card,{" "}
                  <span>add your message</span> and submit an action.
                </Description>
              </Slide>
            </Slider>
          )}
        </GraphicsWrapper>
      </BackDrop>
    </Fragment>
  );
};

KanbanHowTo.propTypes = {
  isRecruiter: PropTypes.bool,
  toggleHowToModal: PropTypes.func.isRequired,
  howToModalActive: PropTypes.bool.isRequired,
};

KanbanHowTo.defaultProps = {
  isRecruiter: PropTypes.isNull,
};

export default KanbanHowTo;
